import { SHOW_NAV } from "../actions/actionTypes";
const initialState = {
  showNav: false,
};

export default function (state = initialState, action) {
  //  (action.payload);
  switch (action.type) {
    case SHOW_NAV:
      return {
        ...state,
        showNav: action.payload,
      };

    default:
      return state;
  }
}
